import { FETCH_USAGE_INDICATORS } from './ActionTypes';

export function fetchUsageIndicators(payload, evictCache) {
    return {
        type: FETCH_USAGE_INDICATORS,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}
